import { type UniqueIdentifier } from '@dnd-kit/core';
import { type ActiveCard } from './DraggableContext';

export function getDraggableId({
  entityId,
  groupId,
  activeGroupId,
  activeCards,
}: {
  entityId: string;
  groupId: UniqueIdentifier;
  activeGroupId?: UniqueIdentifier;
  activeCards?: ActiveCard[];
}) {
  const firstActiveCard = activeCards?.[0];
  const isActiveGroup = activeGroupId === groupId;
  const isFirstActiveCard = firstActiveCard && firstActiveCard.entity.id === entityId;
  if (activeCards && isActiveGroup && isFirstActiveCard) {
    return firstActiveCard.id;
  } else {
    return `${groupId}-${entityId}`;
  }
}
